// @flow

import React from "react";
import styles from "./SelectList.scss";
import CalenderIcon from "../../Calendar/Icons";
import classnames from "classnames";
import { getColor } from "../../../../utils/VenueColors";
import {
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    Typography,
} from "@material-ui/core";

type Props = {
    onSelect: (status: *) => void,
    venueCode: string,
    optionStatus?: string,
    venueUuid?: string,
    type: "ALL" | "EVENT" | "CATEGORY",
    color?: "dark" | "light",
    categories?: *,
    error?: boolean,
    helperText?: *,
    required?: boolean,
    label?: string,
};

const SelectList = ({
    onSelect,
    venueCode,
    optionStatus,
    type,
    color,
    categories,
    error,
    helperText,
    required,
    label,
}: Props) => {
    const status =
        type === "ALL" && optionStatus
            ? optionStatus
            : type === "EVENT" &&
              (optionStatus === "PUBLIC" || optionStatus === "PRIVATE")
            ? optionStatus
            : type === "CATEGORY"
            ? optionStatus
            : "";

    const handleChange = (event: *) => {
        onSelect(event.target.value);
    };

    const allOptions = [
        {
            value: "OPTION_CONFIRMED",
            title: "Confirm",
        },
        {
            value: "LOAD_IN",
            title: "Confirm (Load in)",
        },
        {
            value: "LOAD_OUT",
            title: "Confirm (Load out)",
        },
        {
            value: "REHEARSAL",
            title: "Confirm (Rehearsal)",
        },
        {
            value: "CONSTRUCTION",
            title: "Confirm (Construction)",
        },
        {
            value: "LIMITED_AVAILABILITY",
            title: "Confirm (Limited)",
        },
        {
            value: "PRIVATE",
            title: "Private",
        },
        {
            value: "PUBLIC",
            title: "Public",
        },
        {
            value: "CANCELED",
            title: "Cancel",
        },
    ];

    const eventOptions = [
        {
            value: "PRIVATE",
            title: "Private",
        },
        {
            value: "PUBLIC",
            title: "Public",
        },
    ];

    return (
        <FormControl error={error} fullWidth>
            {label && (
                <InputLabel
                    htmlFor={`test-input`}
                    shrink={!!status}
                    className={classnames(
                        styles.element,
                        color === "dark" && styles.dark,
                        color === "light" && styles.light,
                    )}
                >
                    {label}
                </InputLabel>
            )}
            <Select
                value={status}
                onChange={handleChange}
                name="status"
                displayEmpty
                error={error}
                className={classnames(
                    styles.element,
                    color === "dark" && styles.dark,
                    color === "light" && styles.light,
                )}
                fullWidth
                required={required}
            >
                {type === "ALL" &&
                    allOptions.map(element => (
                        <MenuItem value={element.value} key={element.value}>
                            <CalenderIcon
                                status={
                                    [
                                        "LOAD_IN",
                                        "LOAD_OUT",
                                        "REHEARSAL",
                                        "CONSTRUCTION",
                                    ].includes(element.value)
                                        ? "OPTION_CONFIRMED"
                                        : element.value
                                }
                                color={getColor(venueCode)}
                            />
                            <Typography align="center">
                                {element.title}
                            </Typography>
                        </MenuItem>
                    ))}
                {type === "EVENT" &&
                    eventOptions.map(element => (
                        <MenuItem value={element.value} key={element.value}>
                            <CalenderIcon
                                status={element.value}
                                color={getColor(venueCode)}
                            />
                            <Typography align="center">
                                {element.title}
                            </Typography>
                        </MenuItem>
                    ))}
                {type === "CATEGORY" &&
                    categories &&
                    categories?.map(element => (
                        <MenuItem value={element.uuid} key={element.uuid}>
                            <Typography align="center">
                                {element.name}
                            </Typography>
                        </MenuItem>
                    ))}
            </Select>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default SelectList;
